import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileComponent } from './components/profile/profile.component';
import { StudentProfileService } from './services/student-profile.service';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { StudentProfileComponent } from './components/student-profile/student-profile.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImageModule } from '../../shared/image/image.module';
import { EditProfileComponent } from './components/edit-profile/edit-profile.component';
import { AuthorizationModule } from '../../authorization/authorization.module';
import { StudentEditProfileComponent } from './components/student-edit-profile/student-edit-profile.component';
import { EditProfileService } from './services/edit-profile.service';
import { EditPickupAssistantComponent } from './components/edit-pickup-assistant/edit-pickup-assistant.component';
import { FileUploaderModule } from 'file-uploader';
import { PickupAssistantComponent } from './components/pickup-assistant/pickup-assistant.component';
import { EditPickupWrapperComponent } from './components/edit-pickup-wrapper/edit-pickup-wrapper.component';
import { ErrorsModule } from '../../common/errors/errors.module';
import { PerfectScrollbarConfigInterface, PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { EmergencyContactComponent } from './components/emergency-contact/emergency-contact.component';
import { EditEmgContactWrapperComponent } from './components/edit-emg-contact-wrapper/edit-emg-contact-wrapper.component';
import { EditEmergencyContactComponent } from './components/edit-emergency-contact/edit-emergency-contact.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
	suppressScrollX: true
};

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ImageModule,
    ReactiveFormsModule,
    AuthorizationModule,
    FileUploaderModule,
    ErrorsModule,
    PerfectScrollbarModule
  ],
  declarations: [
    UserProfileComponent
    , StudentProfileComponent
    , ProfileComponent
    , EditProfileComponent
    , StudentEditProfileComponent
    , EditPickupAssistantComponent
    , PickupAssistantComponent
    , EditPickupWrapperComponent
    , EmergencyContactComponent
    , EditEmgContactWrapperComponent
    , EditEmergencyContactComponent
  ],
  providers: [StudentProfileService, EditProfileService,{
    provide: PERFECT_SCROLLBAR_CONFIG,
    useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
  }]
})
export class ProfileModule { }
